module.exports = __webpack_public_path__ + "static/img/login__bg.15eedf8c.svg";